import { FC } from 'react';
import { NextImprovementResponse } from '../types/nextImprovements';

interface Props {
    results: NextImprovementResponse;
};

export const AnalysisSuggestionsPanel: FC<Props> = ({ results }) => {
    console.log("Rendering AnalysisSuggestionsPanel with results:", results);
    return (
        <div className="hero-card suggestions-panel" style={{ marginTop: 24 }}>
            <div className="card">
                <div className="card-header">Next Improvements</div>
                <div className="card-body">
                    <p><strong>Fit Score:</strong> {results.fit_Score}</p>
                    <p><strong>ATS Score:</strong> {results.ats_Score}</p>
                    <p><strong>Recruiter Scan Score:</strong> {results.recruiter_Scan_Score}</p>
                    {results.scoreAdjustmentReason && <p><strong>Score Adjustment Reason:</strong> {results.scoreAdjustmentReason}</p>}
                    <div className="suggestion-list">
                        <p><strong>Improvement Candidates</strong></p>
                        {results.improvement_Candidates?.map((item, index) => (
                            <div className="suggestion-card" key={`${item.type}-${index}`}>
                                <div className="suggestion-card-header">
                                    <div className="suggestion-rank">#{index + 1}</div>
                                    <h4> Impact Score: {item.impact_Estimate} / 100</h4>
                                    <span className="suggestion-type-badge">{item.severity}</span>
                                </div>
                                <p><strong>Skill:</strong> {item.skill}</p>
                                <p><strong>Required:</strong> {item.is_Required ? "Yes" : "No"}</p>
                                <p><strong>Candidate Type:</strong> {item.type}</p>
                                <p><strong>Evidence Confidence:</strong> {item.evidence_Confidence}</p>
                                <p><strong>Truthfulness Risk:</strong> {item.truthfulness_Risk}</p>
                                <p><strong>Reason:</strong> {item.reason}</p>
                                <p><strong>Suggestion:</strong> {item.suggestion}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};